import React from "react";

// import album1 from "../../../assets/music1.webp";
// import album2 from "../../../assets/music2.webp";
// import album3 from "../../../assets/music3.webp";
// import album4 from "../../../assets/music4.webp";
// import album5 from "../../../assets/music5.webp";

import album1 from "../../../assets/new-music3.jpg";
import album2 from "../../../assets/new-music2.png";
import album3 from "../../../assets/new-music1.png";
import album4 from "../../../assets/new-music4.png";
import album5 from "../../../assets/new-music5.jpg";

const UploadAudio = () => {
  return (
    <div className="upload-audio pt-[50px] pb-[40px] lg:pb-[200px]">
      <div className="container mx-auto">
        <div className="text-center">
          <h2 className="text-[40px] font-bold" style={{ lineHeight: "1.2" }}>
            Connect video, audio and <br /> call to action web links{" "}
            <span className="besley italic font-light">in real time</span>
          </h2>

          <p className="text-lg mt-6">
            Use our dashboard to upload and connect your short form content.{" "}
            <br /> Usage statistics show in real time and data can be exported
            via .xls
          </p>

          <div className="album mt-[40px] lg:mt-[100px] relative">
            <div className="shadow-2xl p-5 w-1/5 bg-white rounded-xl mx-auto absolute left-0 top-0">
              <img src={album1} className="w-full" alt="" />
            </div>
            <div className="shadow-2xl p-5 w-1/4 bg-white rounded-xl mx-auto absolute left-[7%] bottom-[-15%]">
              <img src={album2} className="w-full" alt="" />
            </div>
            <div className="shadow-2xl p-5 w-[45%] bg-white rounded-xl mx-auto">
              <img src={album3} className="w-full" alt="" />
            </div>
            <div className="shadow-2xl p-5 w-1/5 bg-white rounded-xl mx-auto absolute right-0 top-[5%]">
              <img src={album4} className="w-full" alt="" />
            </div>
            <div className="shadow-2xl p-5 w-1/6 bg-white rounded-xl mx-auto absolute right-[8%] bottom-[-25%]">
              <img src={album5} className="w-full" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadAudio;
